import * as React from "react";
import { PureG, PureU } from "shared/Components/Shared/pureG";
import { DialogRoots } from "spry-react/DialogPortal/dialogRoots";

import "./signin.less";
import "../../Content/shared/spry/less/spry-login.css";
import { FullPageLoadingBanner } from "shared/Components/shared/fullPageLoadingBanner";

interface Props {
  databaseFriendlyName: string;
  currentYear: number;
  applicationNamePrefix: string;
  applicationName: string;
  signInLogoUrl: string;
}

export class LoginPage extends React.Component<Props> {
  render() {
    const footerCopyright = `${this.props.databaseFriendlyName} | \u00A9 ${this.props.currentYear} | Matrix Pointe Software`;

    return (
      <React.Fragment>
        <FullPageLoadingBanner />
        <DialogRoots />
        <div id="product-background">
          <div className="background-gradient-cover gradient">
            <div className="content flex-vertical">
              <div className="flex-top">
                <div className="product-title matrix-logo">
                  <span className="company-name">{this.props.applicationNamePrefix}</span>
                  {this.props.applicationName}
                </div>
                <div id="login-form">
                  <PureU size="1" className="l-box l-box-vb">
                    <div id="login-db-logo" style={{ backgroundImage: `url(${this.props.signInLogoUrl})` }}></div>
                  </PureU>
                  {this.props.children}
                </div>
              </div>
              <div className="notice-message flex-bottom">
                NOTICE: This site contains confidential, proprietary, and trade secret information belonging to Matrix Pointe Software, LLC (Matrix).
                It is for use by Matrix Clients including justice officials, law enforcement agencies, attorneys and authorized designees thereof
                only. Use by any other person or entity is not authorized. Distribution, dissemination, or other unauthorized use of any material
                contained herein is strictly prohibited and will be subject to penalties as permitted by law. System usage may be monitored, recorded,
                and is subject to audit. Use of the system indicates your consent to these terms.
              </div>
            </div>
          </div>
          <footer id="footer">
            <PureG className="content">
              <PureU size="1-8">
                <span className="matrix-logo">
                  <span className="matrix">Matrix</span>
                </span>
              </PureU>
              <PureU size="1-3" className="tagline l-box-vt-2x">
                The Operating System for Law
              </PureU>
              <PureU size="13-24" className="footer-text">
                {footerCopyright}
                <br />
                30400 Detroit Road, Suite 400 | Cleveland, OH 44145 | 216-865-0025
              </PureU>
            </PureG>
          </footer>
        </div>
      </React.Fragment>
    );
  }
}
